"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LOCALE_TAGS = exports.SUPPORTED_LOCALES = void 0;
exports.normalizeLocale = normalizeLocale;
exports.localeDirection = localeDirection;
exports.SUPPORTED_LOCALES = ['pt', 'en', 'es', 'de', 'fr', 'it', 'nl', 'pl', 'zh', 'hi', 'ar', 'ja'];
exports.LOCALE_TAGS = {
    pt: 'pt-BR', en: 'en-US', es: 'es-419', de: 'de-DE', fr: 'fr-FR', it: 'it-IT', nl: 'nl-NL',
    pl: 'pl-PL', zh: 'zh-CN', hi: 'hi-IN', ar: 'ar', ja: 'ja-JP',
};
function normalizeLocale(language) {
    if (typeof language !== 'string')
        return undefined;
    const base = language.trim().toLowerCase().split('-')[0];
    return exports.SUPPORTED_LOCALES.find((locale) => locale === base);
}
function localeDirection(locale) {
    return locale === 'ar' ? 'rtl' : 'ltr';
}
//# sourceMappingURL=checkout-locale.js.map